import { useMemo, useState } from 'react';
import ArticleCard from '@/components/feature/ArticleCard';
import { allSections, getLatestArticles } from '@/utils/content';

const FILTERS = [{ slug: 'all', shortName: '全部' }, ...allSections];

export default function LatestSection() {
  const [active, setActive] = useState('all');
  const latest = useMemo(() => getLatestArticles(allSections.length * 3), []);

  const visible = useMemo(() => {
    if (active === 'all') {
      return latest.slice(0, 6);
    }
    return latest.filter((item) => item.section === active).slice(0, 6);
  }, [active, latest]);

  return (
    <section id="latest" className="w-full scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.25em] text-secondary-700">最新更新</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              刚刚整理好的话题
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              按分区切换一下，就能只看你关心的那一类内容。
            </p>
          </div>

          <div className="flex flex-wrap gap-2 rounded-full border border-background-200 bg-background-100 p-1">
            {FILTERS.map((filter) => (
              <button
                key={filter.slug}
                type="button"
                onClick={() => setActive(filter.slug)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  active === filter.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:bg-background-200'
                }`}
              >
                {filter.shortName}
              </button>
            ))}
          </div>
        </div>

        {visible.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {visible.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        ) : (
          <div className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-100 p-10 text-center">
            <p className="text-sm text-foreground-600">这个分区暂时还没有新的整理内容，换个分区看看？</p>
          </div>
        )}
      </div>
    </section>
  );
}